<template>
  <div class="d-flex justify-content-center kid-box">
    <div class="kid">
      <hot-spot key="hotspot1" class="hotspot1" color="#ec194d" :index="1"/>
      <hot-spot key="hotspot2" class="hotspot2" color="#a5cf69" :index="2"/>
      <hot-spot key="hotspot3" class="hotspot3" color="#fcdf3a" :index="3"/>
      <hot-spot key="hotspot4" class="hotspot4" color="#d38dff" :index="4"/>
      <hot-spot key="hotspot5" class="hotspot5" color="#ec2926" :index="5"/>
      <hot-spot key="hotspot6" class="hotspot6" color="#ffc2b9" :index="6"/>
      <hot-spot key="hotspot7" class="hotspot7" color="#ac1cd0" :index="7"/>
    </div>
  </div>
</template>

<script>
import HotSpot from "../particle/HotSpot";

import gsap from 'gsap';
import { inject } from "vue";

export default {
  components: {HotSpot},
  data () {},
  setup() {
    const store = inject("store");
    return {
			actions: store.actions,
			state: store.state
    };
  },
  methods: {
    // GSAP transitions
    beforeEnterLanding(el) {
      gsap.set(el, { opacity: 0, x: -1200 });
    },
    enterLanding(el, done) {
			let that = this;

      gsap.to(el, 1, {
        opacity: 1,
        x: 0,
        onComplete: function(){
          if(that.state.firstVisit) {
            that.actions.toggleIntro(true);
          }
          console.log("showHotspots kid")
          that.actions.showHotspots(true);
          done();
        }
      }).delay(0.5);

    },
    leaveLanding(el, done) {
			console.log('leaveLanding');
      gsap.to(el, 0.4, { opacity: 0, onComplete: done });
    },
    beforeEnterHotspot(el) {
      gsap.set(el, { opacity: 0, scale: 0});
    },
    enterHotspot(el, done) {
      gsap.to(el, 1, {
				opacity: 0.8,
				scale: 1.2,
				ease:'ease.easeOut',
			}).delay(3);
      gsap.to(el, 0.7, {
				opacity: 1,
				scale: 1,
				ease:'ease.easeIn',
				onComplete: done
			}).delay(0.7);
    },
  }
}

</script>

<style lang="scss">
.kid {
  width: 865px;
  height: 750px;
  background: url("../../assets/imgs/house.png") no-repeat;
  background-size: contain;
  position: relative;
  margin-right: -15%;
  
}
.kid-box {
  padding-top: 10vh;
  overflow: hidden;
  @media screen and (min-width: 1600px) {
    // padding-top: 25vw;
  }
}
@media (max-width: 424px) {
  .kid-box {
    // padding-top: 42%;
  }
  .kid {
    width: 145%;
    height: 487px;
    margin-right: -175px;
    background-size: contain;
    background-position: 0px 15px;
    overflow: visible;
  }
}
</style>
